export class MetaVisaoAnualDTO {
  UnidadeId: number;
  UnidadeDescricao: string;
  JaneiroMeta: number;
  JaneiroQuantidadeProcessos: number;
  FevereiroMeta: number;
  FevereiroQuantidadeProcessos: number;
  MarcoMeta: number;
  MarcoQuantidadeProcessos: number;
  AbrilMeta: number;
  AbrilQuantidadeProcessos: number;
  MaioMeta: number;
  MaioQuantidadeProcessos: number;
  JunhoMeta: number;
  JunhoQuantidadeProcessos: number;
  JulhoMeta: number;
  JulhoQuantidadeProcessos: number;
  AgostoMeta: number;
  AgostoQuantidadeProcessos: number;
  SetembroMeta: number;
  SetembroQuantidadeProcessos: number;
  OutubroMeta: number;
  OutubroQuantidadeProcessos: number;
  NovembroMeta: number;
  NovembroQuantidadeProcessos: number;
  DezembroMeta: number;
  DezembroQuantidadeProcessos: number;
  TotalMeta: number;
  TotalQuantidadeProcesso: number;
}

export class MetaAnualDetalhes {
  ClienteNome: string;
  Ficha: string;
  ProcessoId: number;
}

export class FiltroMetaDetalhes {
  AnoString: string;
  MesString: string;
  UnidadeId: number;
}